import Heading from "@elements/Typography/Heading";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type ParagraphProps = {
  children: ReactNode;
  id?: string;
  testid?: string;
  className?: string;
};

export default function Paragraph({
  children,
  id,
  testid,
  className,
}: ParagraphProps) {
  return (
    <p
      data-testid={testid}
      className={twMerge(
        "font-primary text-gray-100 text-3sm mb-4 font-normal leading-450",
        className,
      )}
      {...(id && { "data-beyondwords-marker": id })}
    >
      {children}
    </p>
  );
}

export function StandFirst({ children, className }: ParagraphProps) {
  return (
    <Heading
      className={twMerge(
        "text-black-400 font-primary font-semibold leading-8 text-sm",
        className,
      )}
      Element="h6"
    >
      {children}
    </Heading>
  );
}
